import { Divider as Dividers } from 'primereact/divider';  

const Divider = ({...rest}) => {

    return (
        <Dividers {...rest} />
    )

};

export default Divider;